export const CampaignStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};